import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
} from '@angular/core';
import { RR_FILTER_TYPE } from '../../../common/enum/filters/filter-type.enum';
import { RRIFilterOption } from '../../../common/interfaces/filters/filter-options.interface';
import { RRIFilterOutput } from '../../../common/interfaces/filters/filter-output.interface';
import { RRIFilter } from '../../../common/interfaces/filters/filter.interface';
import { RRIInputOption } from '../../../form-inputs/interfaces/input-option.interface';
import { RRIInput } from '../../../form-inputs/interfaces/input-settings.interface';

@Component({
  selector: 'rr-multi-select-filter',
  templateUrl: './multi-select-filter.component.html',
  styleUrls: ['./multi-select-filter.component.scss'],
})
export class MultiSelectFilterComponent<T>
  implements OnInit, OnChanges, AfterViewInit
{
  public multiSelectOptions: RRIFilterOption<T>[];
  public multiSelectSettings: RRIInput<RRIInputOption<T>[]>;

  private _defaultValue: RRIFilterOption<T>[];

  @Input() model: RRIFilter<RRIFilterOption<T>[], T>;
  @Input() options: RRIFilterOption<T>[];
  @Input() formComponentSettings: RRIInput<RRIInputOption<T>[]>;
  @Output() changedFilter: EventEmitter<RRIFilterOutput<RRIFilterOption<T>[]>> =
    new EventEmitter();
  @Output() filterClicked: EventEmitter<RRIFilterOutput<RRIFilterOption<T>[]>> =
    new EventEmitter();
  @Output() cleanFilterClicked: EventEmitter<
    RRIFilter<RRIFilterOption<T>[], T>
  > = new EventEmitter();

  constructor() {}

  ngOnInit(): void {
    this.setMultiSelectSettings();
  }

  ngAfterViewInit(): void {
    this._defaultValue = Object.assign(
      {},
      this.model?.filterBy?.defaultValue ?? [],
    );
    this.setMultiSelectSettings();
  }

  ngOnChanges(): void {
    this.multiSelectOptions = Object.assign({}, this.options);
    this._defaultValue = this.model.filterBy.defaultValue;
  }

  public changeSelectedFilter(event: RRIFilterOption<T>[]): void {
    if (!event) {
      return;
    }
    this.model.filterBy.value = Object.assign([], event);
    this.changedFilter.emit({
      type: RR_FILTER_TYPE.MULTI_SELECT,
      filterBy: {
        ...this.model.filterBy,
        value: event,
      },
    });
  }

  public onClearInput(event: any): void {
    this.setDefaultValues();
    this.cleanFilterClicked.emit(this.model);
  }

  private setMultiSelectSettings(): void {
    if (!this.formComponentSettings) {
      this.multiSelectSettings = {
        fieldName: this.model?.settings?.title ?? '',
        label: this.model?.settings?.title ?? '',
        placeholder: this.model?.settings?.title ?? '',
        tooltip: '',
        defaultValue: null,
      };
      return;
    }
    this.multiSelectSettings = this.formComponentSettings;
  }

  private setDefaultValues(): void {
    if (this.model.filterBy && this.model.filterBy.defaultValue) {
      this.model.filterBy.value = Object.assign([], this._defaultValue);
      this.changedFilter.emit({
        type: RR_FILTER_TYPE.DROPDOWN_SELECT,
        filterBy: {
          ...this.model.filterBy,
          value: Object.assign([], this.model.filterBy.value),
        },
      });
    } else {
      this.changedFilter.emit({
        type: RR_FILTER_TYPE.DROPDOWN_SELECT,
        filterBy: {
          ...this.model.filterBy,
          value: [],
        },
      });
    }
  }
}
